/**
 * Created by Miguel on 23/05/2017
 */
import { Component, OnInit,   } from '@angular/core';
import {UserService} from "../../../services/user.service";
import { AppDataService }  from '../../../services/app-data.service';
import { CompanyService }  from '../../../services/company.service';

declare var $ : any;
declare var Swal: any

@Component({
    selector : 'calendar-modal',
    templateUrl:'calendar-modal.html',
    providers  : [],  
})
export class CalendarModal implements OnInit {
  public list;





  constructor( public _appData : AppDataService,private _companyService : CompanyService,private _auth : UserService) {
  }

  public change(){
    
  }
    public ngOnInit() : any {
      this.list=[{
        date:'26/06/2021 10:00',
        text: 'Aula de Matemática',
        link:'https://liveparty.com.br/gameevent/DUPAY?room=1622424502199'
      }]
    }

    public clickItem(item){
      window.location.href=item.link;
    }

    public sendIframeMessage(messageKind){
      var iframe = document.getElementById('gameFrame');
      if (iframe == null) return;
      var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
      iWindow.postMessage(messageKind, "*");
    }

}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/calendar/calendar-modal.ts